import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";

import useDeleteApp from "../service/useDeleteApp";

export type RevokeSecretForm = {
	password: string;
};

export default function useDeleteAppForm() {
	const schema = Yup.object().shape({
		password: Yup.string().required("Introduce tu contraseña")
	});

	const methods = useForm<RevokeSecretForm>({
		resolver: yupResolver(schema),
		defaultValues: { password: "" }
	});

	const onIncorrectPassword = () => {
		methods.setError("password", { message: "Contraseña incorrecta." });
	};

	const { onDeleteApp, isLoading } = useDeleteApp({ onIncorrectPassword });

	async function onSubmit({ password }: RevokeSecretForm) {
		onDeleteApp(password);
	}

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		isLoading
	};
}
